export default "__VITE_ASSET__CfG385ML__"